import { uniqueId } from "lodash";
import {
  API_ROOT_URL,
  MATERIAL_API,
  MATERIAL_COLOR_CODE_API,
  OP_GET_MATERIAL_API,
} from "../../config/constant/apiConstant";
import api from "../../helpers/axiosHelper";
import { objectToFormData, objectToSearchParams } from "../../helpers/jsHelper";
import { errorToast, infoToast } from "../../helpers/toastHelper";
import { paginatedColorActions } from "../../redux/slicers/admin/paginatedColorSlicer";
import { paginatedMaterialsActions } from "../../redux/slicers/materials/paginatedMaterialSlicer";
import { createDeleteApiAction, createGetListAction, createUpdateApiAction } from "../apiGenerator";
 
export const MaterialEditApi = createUpdateApiAction({
  actions: paginatedMaterialsActions,
  endpointUrl: MATERIAL_API,
})

export const getMaterialListApi = createGetListAction({
  endpoint: MATERIAL_API,
  actions: paginatedMaterialsActions,
})

export const getMaterialListOptimizedApi = createGetListAction({
  endpoint: OP_GET_MATERIAL_API,
  actions: paginatedMaterialsActions,
  useOptimizedAPI: true
})

export const getMaterialColorCodeListApi =
  ({ page, perPage, sort, ...rest }) =>
  (dispatch) => {

    const searchParams = objectToSearchParams({
      page,
      per_page: perPage,
      sort,
      ...rest,
    });

    const API_URL = `${MATERIAL_COLOR_CODE_API}?${searchParams}`;
    const requestId = uniqueId();

    dispatch(paginatedColorActions.fetchListStart({ requestId }));

    api()
      .root(API_ROOT_URL)
      .get(API_URL)
      .success((data) => {
        dispatch(
          paginatedColorActions.fetchListSuccess({
            page: page,
            data,
            requestId,
          })
        );
      })
      .networkError(() => {
        infoToast('Network Error', { toastId: 'NETWORK_ERROR' });
        dispatch(paginatedColorActions.fetchListFailed({ error: new Error('Network error'), requestId }));
      })
      .error((error) => {
        // TODO: add logger
        console.error(error);
        dispatch(paginatedColorActions.fetchListFailed({ error, requestId }));
      })
      .send();
  };

/**
 * @method POST
 * @desc Add color
 */
export const ColorCodeAddApi =
  ({ color, name, memberId }, cb) =>
  (dispatch) => {

    const data = {
      color_value: color,
      member: memberId,
      ...(name && { name })
    }
    
    const formData = objectToFormData(data);
    const temporaryId = uniqueId("temp_id_");

    dispatch(
      paginatedColorActions.addStart({
        data: {
          id: temporaryId,
          isTemporaryItem: true,
          ...data,
        },
      })
    );

    return api()
      .root(API_ROOT_URL)
      .post(MATERIAL_COLOR_CODE_API)
      .data(formData)
      .success((res) => {
        dispatch(
          paginatedColorActions.addSuccess({
            temporaryId,
            data: res.data,
          })
        );
      })
      .error((e) => {
        errorToast("Some error occured");
        // TODO: work on this -> API never calls error if it's a network error or some other specific error
        dispatch(
          paginatedColorActions.addFailed({
            temporaryId,
            error: e,
          })
        );
      })
      .send(cb);
  };

/**
 * @method DELETE
 * @desc Delete color
 */
export const ColorCodeDeleteApi = createDeleteApiAction({
  actions: paginatedColorActions,
  endpointUrl: MATERIAL_COLOR_CODE_API
})


export const ColorCodeUpdateApi = createUpdateApiAction({
  actions: paginatedColorActions,
  endpointUrl: MATERIAL_COLOR_CODE_API,
})